export default function Theme1 (colors, mode) {
    const { grey } = colors

    const contrastText = '#fff'

    let primaryColors = ['#e5e5e5', '#cccccc', '#999999', '#666666', '#323232', '#000000']
    let secondaryColors = ['#fff5e5', '#ffe2b2', '#ffcf7f', '#ffbb4c', '#ffa819', '#ff9f00', '#e58f00', '#4c2f00', '#190f00', '#000000']
    let errorColors = ['#FDE8E7', '#F25E52', '#F04134', '#EE3B2F', '#E92A21']
    let warningColors = ['#FFF7E0', '#FFC926', '#FFBF00', '#FFB900', '#FFA900']
    let infoColors = ['#E0F4F5', '#26B0BA', '#00A2AE', '#009AA7', '#008694']
    let successColors = ['#E0F5EA', '#32a361', '#008d3a', '#007e34', '#00702e']

    let text = ['#020700', '#0C1217', '#616161']
    return {
        ...colors,
        primary: {
            lighter: primaryColors[0],
            100: primaryColors[1],
            200: primaryColors[2],
            light: primaryColors[3],
            400: primaryColors[4],
            main: primaryColors[5],
            dark: primaryColors[5],
            700: primaryColors[5],
            darker: primaryColors[5],
            900: primaryColors[5],
            contrastText
        },
        secondary: {
            lighter: secondaryColors[0],
            100: secondaryColors[1],
            200: secondaryColors[2],
            light: secondaryColors[3],
            400: secondaryColors[4],
            main: secondaryColors[5],
            dark: secondaryColors[6],
            700: secondaryColors[7],
            darker: secondaryColors[8],
            900: secondaryColors[9],
            contrastText
        },
        error: {
            lighter: errorColors[0],
            light: errorColors[1],
            main: errorColors[2],
            dark: errorColors[3],
            darker: errorColors[4],
            contrastText
        },
        warning: {
            lighter: warningColors[0],
            light: warningColors[1],
            main: warningColors[2],
            dark: warningColors[3],
            darker: warningColors[4],
            contrastText
        },
        info: {
            lighter: infoColors[0],
            light: infoColors[1],
            main: infoColors[2],
            dark: infoColors[3],
            darker: infoColors[4],
            contrastText
        },
        success: {
            lighter: successColors[0],
            light: successColors[1],
            main: successColors[2],
            dark: successColors[3],
            darker: successColors[4],
            contrastText
        },
        background: {
            default: '#FAFAF7'
        },
        common: {
            black: '#000',
            white: '#fff'
        },

        text: {
            primary: text[0],
            secondary: text[1],
            hint: text[2],
            contrastText
        },
        action: {
            disabled: grey[300]
        },
        divider: grey[200],
        gridColors: {
            borders: grey[200],
            headerBackground: '#0c1217',
            headerFont: '#FFFFFF',
            headerSvg: '#FFFFFF',
        },
        buttonColors: {
            containedHoverBackground: secondaryColors[5],
            containedHoverColor: primaryColors[5],
            containedColor: contrastText,
            containedBackground: primaryColors[5]
        },
        pageTitle: {
            textColor: primaryColors[5],
            backgroundColor: secondaryColors[5],
            dividerColor: 'rgb(230, 233, 239)'
        },
        drawerBackgroundColor: '#f9f9f9',
        drawerMenuBackgroundColor: '#24292e',
        headerBackgroundColor: '#000000',
        headerBackgroundGradientColor: '#000000',
        inputPalette: {
            labelColor: secondaryColors[9],
            labelBackground: 'rgb(244, 236, 231)',
            inputColor: text[0],
            inputBackground: 'transparent',
            disableUnderline: true,
            borderBottom: `1px dotted ${primaryColors[5]}`
        },
        formBox: {
            titleColor: '#FFFFFF',
            titleBackground: '#000000',
            dividerColor: '#000000'
        },
        linkStyles: {
            hoverColor: infoColors[4],
            color: '#2a5986'
        }
    }
}
